import { render, staticRenderFns } from "./gggl.vue?vue&type=template&id=15812226&scoped=true&"
import script from "./gggl.vue?vue&type=script&lang=js&"
export * from "./gggl.vue?vue&type=script&lang=js&"
import style0 from "./gggl.vue?vue&type=style&index=0&id=15812226&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15812226",
  null
  
)

export default component.exports